// extracted by mini-css-extract-plugin
export var container = "Adress-module--container--3S3z8";
export var container__title = "Adress-module--container__title--3Z7nd";
export var container__par = "Adress-module--container__par--1r_4K";